export default "/_next/static/images/685995ed7c3ce88d04399589ed6ee16b.jpg";